import React from 'react';

const RightPointerIcon = () => {
  return (
    <svg className="right-pointer-icon" width="21px" height="16px" viewBox="0 0 21 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Pointer-Right Icon</title>
      <defs />
      <g id="Admin" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="right-pointer-icon" className="svg" transform="translate(-1306.000000, -919.000000)" fill="currentColor">
          <g id="Content">
            <g id="Add-New-User-Popover-Rev1">
              <g id="Content" transform="translate(1040.000000, 0.000000)">
                <g id="Form---Step-1" transform="translate(0.000000, 88.000000)">
                  <g id="Button" transform="translate(40.000000, 816.000000)">
                    <path d="M244.489046,23 L226,23 L226,22 L244.12302,22 L237.770499,15.6474788 L238.477606,14.940372 L245.51314,21.9759059 L245.548674,21.940372 L246.25578,22.6474788 L246.220247,22.6830127 L246.25578,22.7185466 L245.548674,23.4256534 L245.51314,23.3901195 L238.477606,30.4256534 L237.770499,29.7185466 L244.489046,23 Z" id="Arrow-Right" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default RightPointerIcon;
